export default "/mqEditor/./assets/icons-custom.png";